import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Tipo {
  idTipos: number;
  tipos: string;
  estado: number;
  fecha: string;
  modificado: string;
  usuario: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class TiposService {
  private apiUrl =  `${environment.apiUrl}/api/tipos`; 
  //private apiUrl = 'http://localhost:3000/api/tipos';

  constructor(private http: HttpClient) {}

  // Crear un nuevo tipo
  createTipo(tipo: Tipo): Observable<Tipo> {
    return this.http.post<Tipo>(this.apiUrl, tipo, {
      withCredentials: true
    }).pipe(
      catchError(error => {
        let message = 'Error en la solicitud.';
        return throwError(() => new Error(message));
      })
    );
  }

  // Obtener todos los tipos
  getTipos(): Observable<Tipo[]> {
    return this.http.get<Tipo[]>(this.apiUrl, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Obtener un tipo por ID
  getTipoById(id: number): Observable<Tipo> {
    return this.http.get<Tipo>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Actualizar un tipo
  updateTipo(id: number, tipo: Tipo): Observable<Tipo> {
    return this.http.put<Tipo>(`${this.apiUrl}/${id}`, tipo, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Eliminar un tipo
  deleteTipo(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Inactivar un tipo
  inactivarTipo(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/inactivar/${id}`, { estado: 0 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Activar un tipo
  activarTipo(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/activar/${id}`, { estado: 1 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Manejo de errores
  private handleError(error: any) {
    console.error('Ocurrió un error:', error);
    const message = error.message || 'Error en la solicitud.';
    return throwError(() => new Error(message));
  }
}
